import styled, { css } from 'styled-components';

const fadeStyle = css`
  content: '';
  position: absolute;
  top: 0;
  bottom: 12px;
  width: 40px;
  transition: opacity 0.2s ease;
  pointer-events: none;
  z-index: 1;
`;

export const Container = styled.div<{ $fadeLeft?: boolean; $fadeRight?: boolean }>`
  position: relative;

  &::before {
    ${fadeStyle}
    opacity: ${({ $fadeLeft = false }) => ($fadeLeft ? 1 : 0)};
    left: 0;
    background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  &::after {
    ${fadeStyle}
    opacity: ${({ $fadeRight = false }) => ($fadeRight ? 1 : 0)};
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }
`;

export const Content = styled.div`
  flex-wrap: nowrap;
  overflow-y: auto;
`;

export const ScrollButton = styled.button<{ $position: 'left' | 'right' }>`
  background-color: ${({ theme }) => theme.colors['neutral-30']};
  border-radius: 4px;
  left: ${({ $position }) => ($position === 'left' ? '8px' : 'unset')};
  right: ${({ $position }) => ($position === 'right' ? '8px' : 'unset')};
  top: calc(50% - 12px);
  transform: translateY(-50%);
  position: absolute;
  padding: 4px;
  z-index: 2;
  transition: opacity 0.2s ease;

  & > svg {
    fill: ${({ theme }) => theme.colors['neutral-100']};
    width: 12px;
    height: 12px;
    display: block;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0;
  }
`;
